/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  var $searchToggler = $('.js-search-toggler');
  var $searchInputWrapper = $('.js-search-input-wrapper');
  var $searchInput = $('.js-search-input');
  var $searchIcon = $('.js-search-icon');

  var $hamburger = $('.js-hamburger');
  var $menu = $('.js-menu');
  var $menuWrapper = $('#menus');

  var resetSearch = function resetSearch() {
    $searchInputWrapper.addClass('js-dn');
    $searchIcon.removeClass('active');
    return $searchInput.val("");
  };

  // Click outside the search, close and clear the search
  $(window).click(function(e) {
    var $target = $(e.target);

    if (!$target.closest($searchToggler).length &&
        !$target.closest($searchInputWrapper).length &&
        $searchInputWrapper.is(':visible')) {
          resetSearch();
    }
  });

  $searchToggler.on('click', function(e) {
    // Display the input and focus
    if ( $searchIcon.hasClass('active') ) {
      $searchInputWrapper.addClass('js-dn');
      $searchIcon.removeClass('active');
    } else {

      $menu.addClass('js-dn');
      $menuWrapper.removeClass('menu-active');
      $hamburger.removeClass('active');

      $searchInputWrapper.removeClass('js-dn');
      $searchIcon.addClass('active');
      return $searchInput.focus();
    }

  });
});
